export const stripEndSlash = (str: string) =>
  str && str[str.length - 1] === '/' ? str.slice(0, str.length - 1) : str
